/**
 * Converts a string containing a regular expression into an array
 * of two strings -- 0 representing the regex op, 1 representing
 * the match
 *
 * @param regexp string containing the regex
 * @returns {string[]}
 */
export const friendlyRegex = (regexp) => {
    const data = [];
    if (regexp.startsWith('^')) {
        // Starts With
        data.push('Starts With');
        data.push(regexp.replace('^', '').replace('.*', '').replace('\\.', '.'));
    }
    else if (regexp.endsWith('$')) {
        // Ends With
        data.push('Ends With');
        data.push(regexp.replace('$', '').replace('.*', '').replace('\\.', '.'));
    }
    else if (regexp.startsWith('.*') && regexp.endsWith('.*')) {
        // Contains
        data.push('Contains');
        data.push(regexp.replace(/\.\*/g, '').replace('\\.', '.'));
    }
    else {
        data.push('Full Match');
        data.push(regexp.replace('\\.', '.'));
    }
    return data;
};
export default friendlyRegex;
